import Dialog from "../../atoms/dialog";
import { Button, Typography, Box } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import DeleteDigitalTwin from "../DigitalTwins/DeleteDigitalTwin";

const DeleteDigitalTwinAlert = (props) => {
    const { onCompletion, element, onClose, setShowDeleteAlert } = props;


    const [open, setOpen] = useState(false)


    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (

        <Dialog
            // title={"Delete"}
            open={true}
            handleClose={handleClose}
        >

            <DeleteDigitalTwin onCompletion={onCompletion} setShowDeleteAlert={setShowDeleteAlert} element={element} onClose={onClose} />

        </Dialog >
    )

}

export default DeleteDigitalTwinAlert;